export const createChildParentMapping = function () {
  let treeNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const childParentsMap = {};
  const parentChildrenMap = {};
  function updateMappingData() {
    let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let isDisabled = arguments.length > 2 ? arguments[2] : undefined;
    childParentsMap[item.id] = parents; // child and it's parents mapping

    const childNodes = item.children || []; // getting children of current node to populate parent & its children mapping
    let extendedParents = [];
    if (childNodes?.length) {
      extendedParents = [...parents, item.id];
      childNodes.forEach(childNode => {
        const isItemDisabled = isDisabled || childNode?.disabled;
        parentChildrenMap[item.id] = isItemDisabled ? [...(parentChildrenMap[item.id] || [])] : [...(parentChildrenMap[item.id] || []), childNode?.id]; // updating parent childrens map in same loop to avoid looping over child nodes twice
        updateMappingData(childNode, extendedParents, isItemDisabled);
      });
    } else {
      parentChildrenMap[item.id] = [];
    }
  }
  treeNodes.forEach(treeNode => updateMappingData(treeNode, [], treeNode?.disabled));
  return {
    parentChildrenMap,
    childParentsMap
  };
};
export const computeChecked = function () {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let checked = arguments.length > 1 ? arguments[1] : undefined;
  let indeterminate = arguments.length > 2 ? arguments[2] : undefined;
  let childParentsMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let parentChildrenMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let newChecked = new Set([...checked, id]);
  let newIndeterminate = new Set([...indeterminate]);
  // check if any of checked item's parent ids need to be checked
  let parents = [...(childParentsMap[id || ''] || [])];
  parents?.reverse();
  parents.forEach(parentId => {
    const siblingIds = parentChildrenMap[parentId] || []; // get siblingNodes
    const siblingCount = siblingIds.length;
    if (siblingCount) {
      let siblingIndex = 0;
      for (siblingIndex = 0; siblingIndex < siblingIds.length; siblingIndex++) {
        if (!newChecked?.has(siblingIds[siblingIndex])) {
          break;
        }
      }
      if (siblingIndex == siblingCount) {
        // if all siblings are also checked
        // mark parent checkbox as checked
        newChecked?.add(parentId);
        newIndeterminate.delete(parentId);
      } else {
        // mark parent checkbox as indeterminate
        newIndeterminate?.add(parentId);
      }
    }
  });

  // check if any of checked item's children ids need to be checked
  checkChildIds(id, parentChildrenMap, newChecked, newIndeterminate, true);
  return {
    newChecked,
    newIndeterminate
  };
};
export const computeUnChecked = function () {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let checked = arguments.length > 1 ? arguments[1] : undefined;
  let indeterminate = arguments.length > 2 ? arguments[2] : undefined;
  let childParentsMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let parentChildrenMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let newChecked = new Set([...checked]);
  newChecked.delete(id);
  let newIndeterminate = new Set([...indeterminate]);
  newIndeterminate.delete(id);
  // check if any of unchecked item's parent ids need to be unchecked
  let parents = [...(childParentsMap[id] || [])];
  parents?.reverse();
  parents.forEach(parentId => {
    const siblingIds = parentChildrenMap[parentId] || []; // get siblingNodes
    const siblingCount = siblingIds.length;
    let siblingIndex = 0;
    for (siblingIndex = 0; siblingIndex < siblingIds.length; siblingIndex++) {
      if (newChecked?.has(siblingIds[siblingIndex]) || newIndeterminate?.has(siblingIds[siblingIndex])) {
        break;
      }
    }
    newChecked?.delete(parentId);
    if (siblingIndex == siblingCount) {
      // if all siblings are also unchecked
      // mark parent checkbox as unchecked
      newIndeterminate?.delete(parentId);
    } else {
      // mark parent checkbox as indeterminate
      newIndeterminate?.add(parentId);
    }
  });

  // check if any of unchecked item's children ids need to be unchecked
  checkChildIds(id, parentChildrenMap, newChecked, newIndeterminate, false);
  return {
    newChecked,
    newIndeterminate
  };
};
const checkChildIds = function (nodeId) {
  let parentChildrenMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let newChecked = arguments.length > 2 ? arguments[2] : undefined;
  let newIndeterminate = arguments.length > 3 ? arguments[3] : undefined;
  let isCheckAction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  const immediateChildIds = parentChildrenMap[nodeId || ''] || [];
  if (immediateChildIds.length) {
    const selectOrUnselectAllChildren = function () {
      let childId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      isCheckAction ? newChecked.add(childId) : newChecked.delete(childId);
      newIndeterminate.delete(childId);
      const grandChildrenIds = parentChildrenMap[childId] || [];
      if (grandChildrenIds.length) {
        grandChildrenIds.forEach(grandChildId => {
          selectOrUnselectAllChildren(grandChildId);
        });
      }
    };
    immediateChildIds.forEach(childId => {
      selectOrUnselectAllChildren(childId);
    });
  }
};
export const computeIndeterminate = function () {
  let initialChecked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let childParentsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let newIndeterminate = [];
  initialChecked.forEach(checkedId => {
    const parentIds = childParentsMap?.[checkedId] || [];
    parentIds.forEach(parentId => {
      if (!initialChecked.includes(parentId)) {
        newIndeterminate.push(parentId);
      }
    });
  });
  return newIndeterminate;
};